import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";

import ImportExportNav from "./ImportExportNav";
import userHasAccess from "../../../utils/userHasAccess";
import { ADMINISTRATOR, DIRECTOR, FINTECH, MANAGER } from "../../../utils/Roles";

class ImportExportPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleRoleNavRedirection = this.handleRoleNavRedirection.bind(this);
  }

  componentWillMount() {
    this.handleRoleNavRedirection();
  }

  componentWillUpdate() {
    this.handleRoleNavRedirection();
  }

  handleRoleNavRedirection() {
    if(window.location.pathname === "/dashboard/transfer") {
      if(userHasAccess([ADMINISTRATOR, FINTECH, DIRECTOR, MANAGER], true)) {
        this.context.router.push("/dashboard/transfer/import");
      }
  
      else {
        this.context.router.push("/dashboard/transfer/accounting-exports");
      }
    }
  }

  render() {
    const { children } = this.props;
    return (
      <div>
      <div className="page-header">
        <div className="main clearfix">
          <div className="main-name">
            <h2>
              <FormattedMessage id="importExport.title" />
            </h2>
          </div>
        </div>
        <ImportExportNav />
      </div>
      {!!children ? (
        <div className="sub-container import-export-page">{children}</div>
      ) : (
        ""
      )}
    </div>
    );
  }

}

ImportExportPage.propTypes = {
  children: PropTypes.node,
};

ImportExportPage.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export default ImportExportPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/ImportExportPage.js